<header class="top-bar">
  <div class="top-bar-container">
    <div class="top-bar-left">
      <img src="assets/images/whiteLogo.svg" alt="Logo" class="logo" />

      <div class="user-profile">
        <div class="user-avatar">
          <img
            [src]="medicalStaffInfo.avatar"
            alt="Avatar"
            class="avatar-img"
          />
        </div>
        <div class="user-info">
          <span class="user-name"
            >{{ medicalStaffInfo.firstname }}
            {{ medicalStaffInfo.lastname }}</span
          >
          <span class="user-role">Personnel médical</span>
        </div>
      </div>
    </div>

    <div class="top-bar-right">
      <a
        routerLink="/medical-staff/home"
        routerLinkActive="active"
        class="nav-link"
      >
        <i class="feather icon-home"></i>
        <span>Accueil</span>
      </a>
      <a
        routerLink="/medical-staff/assistant"
        routerLinkActive="active"
        class="nav-link"
      >
        <i class="feather icon-message-circle"></i>
        <span>Assistant</span>
      </a>
      <a
        routerLink="/medical-staff/mes-secteurs"
        routerLinkActive="active"
        class="nav-link"
      >
        <i class="feather icon-activity"></i>
        <span>Mes Secteurs</span>
      </a>

      <button class="btn btn-link logout-btn" (click)="logout()">
        <i class="feather icon-log-out"></i>
        <span class="logout-text">Déconnexion</span>
      </button>
    </div>
  </div>
</header>
